"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdCircleStep = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../../components/organisms");
const ThirdCircleStep = () => {
    return (react_1.default.createElement(organisms_1.TimelineEntry, { checked: true, title: "Erstgespr\u00E4ch", subTitle: '', infoText: "Sie hatten Ihr Erstgespr\u00E4ch mit Ihrem Arzt." }));
};
exports.ThirdCircleStep = ThirdCircleStep;
